import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { RadioGroup, RadioGroupItem } from "../ui/radio-group";

const REASONS = [
  { code: "missing_info", label: "Missing info" },
  { code: "over_my_level", label: "Over my level" },
  { code: "wrong_return_type", label: "Not my kind of work" },
  { code: "no_time", label: "No time" },
  { code: "other", label: "Other" },
];

export const ReleaseDialog = ({ item, open, onOpenChange, onConfirm, busy }) => {
  const [reason, setReason] = useState("missing_info");
  const [note, setNote] = useState("");

  const submit = () => onConfirm({ reason_code: reason, note: note.trim() || null });

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="release-dialog">
        <DialogHeader>
          <DialogTitle>Release {item?.client_name}</DialogTitle>
          <DialogDescription>
            This goes back on the shelf for anyone to claim. A reason is required.
          </DialogDescription>
        </DialogHeader>

        <RadioGroup value={reason} onValueChange={setReason} className="gap-2.5">
          {REASONS.map((r) => (
            <div key={r.code} className="flex items-center gap-2.5">
              <RadioGroupItem value={r.code} id={`reason-${r.code}`} data-testid={`release-reason-${r.code}`} />
              <Label htmlFor={`reason-${r.code}`} className="font-normal cursor-pointer">
                {r.label}
              </Label>
            </div>
          ))}
        </RadioGroup>

        <div className="space-y-1.5">
          <Label htmlFor="release-note" className="text-xs uppercase tracking-wider text-muted-foreground">
            Note (optional)
          </Label>
          <Textarea
            id="release-note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Anything the next person should know"
            data-testid="release-note-input"
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="release-cancel-btn">
            Cancel
          </Button>
          <Button onClick={submit} disabled={busy} data-testid="release-confirm-btn">
            {busy ? "Releasing…" : "Release to shelf"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
